import api from './axios';
import {authHeader} from '../helpers';
import {authService} from './authentication.service';

export const donneeTopoService = {
    getFiliations,
    createOrUpdate,
    createView,
    deleteView,
    getByElementId,
    getCampagneByElementId,
    getCodeInseeByCenterPosition,
    getInfosPourCadastre,
    getListVueByRdN,
    updateView
};

async function getFiliations(idRdN) {
    return api.get(`/DonneeTopo/Affiliations/GetByRdN/${idRdN}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function createOrUpdate(idElement, parametresJson) {
    return api.post(`/DonneeTopo?idElement=${idElement}`, parametresJson, {
        headers: {
            'Content-Type': 'application/json',
            ...authHeader()
        }
    })
        .catch(error => {
            throw error;
        });
}

async function createView(vue) {
    return api.post('/DonneeTopo/Vue/Create', vue, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function deleteView(viewId) {
    return api.post(`/DonneeTopo/Vue/Delete/${viewId}`, null, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getByElementId(idElement) {
    try {
        const response = await api.get(`/DonneeTopo?idElement=${idElement}`, {
            headers: authHeader()
        });

        if (response.data) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        throw error;
    }
}

async function getCampagneByElementId(rdnId) {
    return api.get(`/DonneeTopo/${rdnId}/Campagne`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function getCodeInseeByCenterPosition(lon, lat) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`${process.env.VUE_APP_API_GEO_GOUV}/communes?lon=${lon}&lat=${lat}`, requestOptions)
        .then(async response => {
            if (!response.ok) {
                if (response.status === 401) {
                    await authService.logout()
                }

                const error = await response.text()

                return Promise.reject(error)
            }

            const data = await response.json()
            return data
        })
}

async function getInfosPourCadastre(codeInsee) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    }

    return fetch(`https://inspire.cadastre.gouv.fr/scpc/${codeInsee}.wms?service=WMS&request=GetCapabilities`, requestOptions)
        .then(async response => {
            if (!response.ok) {
                if (response.status === 401) {
                    await authService.logout()
                }

                const error = await response.text()

                return Promise.reject(error)
            }

            const xmlText = await response.text()
            return xmlText
        })
}

async function getListVueByRdN(rdnId) {
    return api.get(`/DonneeTopo/Vue/List/${rdnId}`, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}

async function updateView(vue) {
    return api.post('/DonneeTopo/Vue/Update', vue, {
        headers: authHeader()
    })
        .then(authService.handleResponse);
}
